import { render, staticRenderFns } from "./RatingPicker.vue?vue&type=template&id=71f79fa0&"
import script from "./RatingPicker.vue?vue&type=script&lang=js&"
export * from "./RatingPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports